import Notifications from '@/services/notifications'

const fetchNotifications = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Notifications.unread().then((response) => {
      commit('SET_NOTIFICATIONS', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const markAllAsRead = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Notifications.markAllAsRead().then((response) => {
      commit('SET_NOTIFICATIONS', [])
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const markAsRead = async ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    Notifications.markAsRead().then((response) => {
      commit('REMOVE_NOTIFICATION', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  fetchNotifications,
  markAllAsRead,
  markAsRead
}



// WEBPACK FOOTER //
// ./src/features/notifications/store/actions.js